<div class="loader-panel">
  <mat-spinner diameter="70"></mat-spinner>
  <div>
    <h3 class="title">Loading...</h3>
    <p class="please-wait">Please wait while the application loads</p>
  </div>
</div>
